import { Button, Col, Form, FormGroup, Modal, Row } from "react-bootstrap";
import ThemedModal from "../../../@ui/Modal/ThemedModal";
import { PublicTransportDownloadSource } from "../../../types/LayerAdmin/PublicTransportDownloadSource";
import { PublicTransportDownloadSourceStatus } from "../../../constant/PublicTransportDownloadSourceStatus";
import { useMemo, useState } from "react";
import FileUploader from "../../../@ui/FileUploader";
import * as Yup from "yup";
import { Formik } from "formik";
import { usePublicTransportService } from "../../../hooks";
import { set } from "lodash";

export interface PatchSourceModalProps {
    source: PublicTransportDownloadSource;
    onClose: () => void;
    onPatched: () => void;
    show: boolean;
}

interface UploadForm {
    gtfsFile?: File | null;
}

export const PatchSourceModal = ({ source, show, onClose, onPatched }: PatchSourceModalProps) => {
    const publicTransportService = usePublicTransportService();
    const [isPatching, setIsPatching] = useState(false);

    const submit = (values: UploadForm) => {
        const { gtfsFile } = values;
        setIsPatching(true);
        publicTransportService.PatchDownloadSource(source.id, gtfsFile!).then(() => {
            onPatched();
            onClose();
        }).catch((error: any) => {
            console.error("Error uploading patch ile...");
        }).finally(() => {
            setIsPatching(false);
        });
    };

    const isPatch = useMemo(() => {
        return source.status === PublicTransportDownloadSourceStatus.Patched || source.status === PublicTransportDownloadSourceStatus.Success;
    }, [source]);

    const uploadSchema = Yup.object().shape({
        gtfsFile: Yup.mixed().required("GTFS File is required")
    });


    return <>
        <ThemedModal centered show={show} onHide={onClose}>
            <Formik
                onSubmit={submit}
                initialValues={{ gtfsFile: null }}
                validationSchema={uploadSchema}
            >
                {({
                    handleSubmit,
                    setFieldValue,
                    setTouched,
                }) => (
                    <Form onSubmit={handleSubmit}>
                        <Modal.Header>
                            <Modal.Title>{isPatch ? "Overwrite" : "Upload"} Source</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Row className="justify-content-center">
                                <Col className="col-md-10">You will be {isPatch ? "overwriting" : "uploading"} a new source file for {source.name}.</Col>
                            </Row>
                            <Row className="justify-content-center">
                                <Col className="col-md-10">
                                    <FormGroup className="w-100 mt-2">
                                        <Form.Label>GTFS Zip:</Form.Label>
                                        <FileUploader
                                            onClear={() => setFieldValue("gtfsFile", undefined)}
                                            onChange={(file) => {
                                                setFieldValue("gtfsFile", file);
                                            }}
                                            onBlur={(_) => setTouched({ gtfsFile: true })}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            {isPatching && <Row className="justify-content-center">
                                <Col className="col-md-10 text-warning">Uploading in progress, this might take a couple of minutes.</Col>
                            </Row>}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={onClose}>Cancel</Button>
                            <Button variant={isPatch ? "danger" : "success"} type="submit" disabled={isPatching}>{isPatch ? "Overwrite" : "Upload"}</Button>
                        </Modal.Footer></Form>
                )}
            </Formik>
        </ThemedModal>
    </>
}